// src/components/TeamMemberCard.jsx

function TeamMemberCard({ member }) {
  return (
    <div className="team-member-card">
      <div className="card-inner">
        {/* Front side of the card */}
        <div className="card-front">
          <img src={member.photo} alt={member.name} className="team-member-photo" />
          <h3 className="team-member-name">{member.name}</h3>
          <p className="team-member-dept">{member.department}</p>
        </div>

        {/* Back side of the card */}
        <div className="card-back">
          <h4 className="card-back-title">Contact Info</h4>
          <a href={`mailto:${member.email}`} className="member-email-link">
            <i className="fas fa-envelope"></i> {member.email}
          </a>
          <div className="social-links">
            {member.socials.linkedin && <a href={member.socials.linkedin} target="_blank" rel="noopener noreferrer"><i className="fab fa-linkedin"></i></a>}
            {member.socials.twitter && <a href={member.socials.twitter} target="_blank" rel="noopener noreferrer"><i className="fab fa-twitter"></i></a>}
            {member.socials.github && <a href={member.socials.github} target="_blank" rel="noopener noreferrer"><i className="fab fa-github"></i></a>}
            {member.socials.dribbble && <a href={member.socials.dribbble} target="_blank" rel="noopener noreferrer"><i className="fab fa-dribbble"></i></a>}
          </div>
        </div>
      </div>
    </div>
  );
}

export default TeamMemberCard;